import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import { termPropTypes } from "common/Term.js";

export default class FoodSafetyMissionsSearchFormFields extends PureComponent {
	static propTypes = {
		t: PropTypes.func.isRequired,
		countries: PropTypes.array.isRequired,
		years: PropTypes.array.isRequired,
		categories: PropTypes.arrayOf(termPropTypes)
	};

	render() {
		const { t, countries, years, categories } = this.props;
		return (
			<Fragment>
				<div className="field-type-text search">
					<label htmlFor="field-name-q">{t("ListingPage.food_safety_missions.search")}</label>
					<input id="field-name-q" type="text" maxLength="64" name="q" />
				</div>
				<div className="field-type-select">
					<label htmlFor="field-name-country">{t("ListingPage.food_safety_missions.country")}</label>
					<select id="field-name-country" name="country">
						<option value="">{t("ListingPage.food_safety_missions._country")}</option>
						{countries
							.map(country => country.split("|"))
							.map(country => (
								<option key={country[0]} value={country[0]}>
									{country[1]}
								</option>
							))}
					</select>
				</div>
				<div className="field-type-select">
					<label htmlFor="field-name-year">{t("ListingPage.food_safety_missions.year")}</label>
					<select id="field-name-year" name="year">
						<option value="">{t("ListingPage.food_safety_missions._year")}</option>
						{years.map(year => (
							<option key={year}>{year}</option>
						))}
					</select>
				</div>
				{categories && (
					<div className="field-type-select">
						<label htmlFor="field-name-category">{t("ListingPage.food_safety_missions.category")}</label>
						<select id="field-name-category" name="category">
							<option value="">{t("ListingPage.food_safety_missions._category")}</option>
							{categories.map(term => (
								<option key={term.id} value={term.id}>
									{term.title}
								</option>
							))}
						</select>
					</div>
				)}
			</Fragment>
		);
	}
}
